import { user } from './user'
import { goods } from './goods'
import { admin } from './admin'
import { order } from './order'

export const api = {
  user,
  goods,
  admin,
  order,
}
